import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-prevoyance-particuliers',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-prevoyance-particuliers.component.html',
  styleUrl: './assurance-prevoyance-particuliers.component.scss'
})
export class AssurancePrevoyanceParticuliersComponent {
  title = 'Assurance Prévoyance Particuliers';
  subtitle = 'Protégez vos proches en cas d\'accident, maladie ou décès';
  heroImage = 'assets/images/prevoyance-hero.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Prévoyance', link: undefined }
  ];

  prevPage = { title: 'Assurance Santé Particuliers',
    link: '/assurance-sante-particuliers'
  };

  nextPage = { title: 'Assurance Auto Particuliers',
    link: '/assurance-auto-particuliers'
  };

  constructor(private router: Router) {}

  navigateToComparison() {
    this.router.navigate(['/cac/comparaison']);
  }
}

